import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trigger", "panel", "icon"];
  static values = { open: Boolean };

  toggle() {
    this.openValue = !this.openValue;
  }

  openValueChanged(open) {
    this.panelTarget.classList.toggle("hidden", !open);
    this.iconTarget.classList.toggle("rotate-180", open);
    this.triggerTarget.setAttribute("aria-expanded", open);
  }
}
